export const DIMENSIONS_ENABLED_BY_FILTERS = {
    customer_movement_type_detailed_key: {
        requiredFilters: ['brandsFilters', 'barcodeFilters', 'itemFilters'],
        tooltip: 'dataTablePerformance.dimension.customer_movement_type_detailed_key.chip.tooltip',
        showTooltipWhenEnabled: false
    }
};
//# sourceMappingURL=dimensionsEnabledByFilters.constant.js.map